import { AxiosResponse } from "axios";
import Api from "./Api";

export type Customer = TestRequestRaw.Schemas.Customer;
export type TestRequestDescriptionRq = TestRequestRaw.Schemas.TestRequestDescriptionRq;
export type TesaLeapRequestValue = TestRequestRaw.Schemas.TesaLeapRequestValue;
export type TesaLeapOpportunityValue = TestRequestRaw.Schemas.TesaLeapOpportunityValue;
export type TesaOpportunityProductValue = TestRequestRaw.Schemas.TesaOpportunityProductValue;
export type TesaDistributorId = TestRequestRaw.Schemas.TesaDistributorId;

class CrmTestRequestApi {
  constructor(private api: Api) {}

  public getCrmTestRequest(
    applicationType: string,
    opportunityId: string,
  ): Promise<AxiosResponse<TesaLeapRequestValue>> {
    const params = new URLSearchParams([
      ["applicationType", applicationType],
      ["opportunityId", opportunityId],
    ]);

    return this.api.get("/test-request/v2/applications/crm-testrequest", {
      params,
    });
  }

  public getCrmCustomerReferenceByOpportunityId(opportunityId: string): Promise<AxiosResponse<Customer>> {
    const params = new URLSearchParams([["opportunityId", opportunityId]]);
    return this.api.get("/test-request/v2/applications/customer-reference", { params });
  }

  public getCrmOpportunityById(opportunityId: string): Promise<AxiosResponse<TesaLeapOpportunityValue>> {
    const params = new URLSearchParams([["opportunityId", opportunityId]]);
    return this.api.get("/test-request/v2/applications/crm-opportunity", { params });
  }

  public getCrmOpportunityProductById(opportunityId: string): Promise<AxiosResponse<TesaOpportunityProductValue[]>> {
    const params = new URLSearchParams([["opportunityId", opportunityId]]);
    return this.api.get("/test-request/v2/applications/crm-opportunity-products", { params });
  }

  public updateCrmTestRequest(tesaLeapId: string, data: TestRequestDescriptionRq): Promise<AxiosResponse<unknown>> {
    return this.api.put(`/test-request/v2/applications/crm-testrequest-update/${tesaLeapId}`, data);
  }

  public createCrmTestRequest(
    testRequestId: string,
    tesaType: string,
    tesaLeapPortalUrl: string,
    data: TestRequestDescriptionRq,
  ): Promise<AxiosResponse<unknown>> {
    const params = new URLSearchParams([
      ["tesaType", tesaType],
      ["testRequestId", testRequestId],
      ["tesaLeapPortalUrl", tesaLeapPortalUrl],
    ]);
    return this.api.post(`/test-request/v2/applications/crm-testrequest-create/?${params.toString()}`, {
      ...data,
    });
  }
}

export default CrmTestRequestApi;
